// QR customer-facing pages only (namespace: "qr"). Supports en, ar, fr, es.
// Portal keeps its own en/ar `translation` namespace; keep QR keys here.
const qr_en = {
  add: "Add",
  additional_info: "Additional Info",
  all: "All",
  amount: "Amount",
  basket: "Basket",
  basket_empty: "Your basket is empty!",
  calories: "Calories",
  cancel: "Cancel",
  cart: "Cart",
  change_mode: "Change Mode",
  customer_name: "Customer Name",
  done: "Done",
  failed_to_load_order_history: "Failed to load order history",
  failed_to_load_products: "Failed to load products",
  home: "Home",
  how_would_you_like_to_order: "How would you like to order?",
  insufficient_quantity: "Insufficient Quantity",
  items: "Items",
  menu: "Menu",
  no: "No",
  no_menu_data_found: "No menu data found",
  options: "Options",
  order_confirmed: "Order Confirmed",
  order_id: "Order ID",
  order_placed_successfully: "Your order has been placed successfully!",
  order_with_ai: "Order with AI",
  order_yourself: "Order yourself",
  out_of_stock: "Out of Stock",
  place_new_order: "Place New Order",
  place_order: "Place Order",
  please_scan_valid_qr_code_or_try_again_later:
    "Please scan a valid QR code or try again later.",
  search_product_name_here: "Search product name here",
  select_language: "Select Language",
  select_options: "Select Options",
  selected_item: "Selected Item",
  skip: "Skip",
  something_went_wrong: "Something went wrong",
  status: "Status",
  subtotal: "SubTotal",
  successfully_added: "Successfully Added",
  taxes: "Taxes",
  total: "Total",
  touch_screen: "Touch Screen",
  validate_customer_name_required: "The Customer name field is required.",
  validate_vehicle_color_required: "The Vehicle color field is required.",
  validate_vehicle_number_required: "The Vehicle number field is required.",
  vehicle_color: "Vehicle Color",
  vehicle_number: "Vehicle Number",
  view_details: "View Details",
  voice_assistant: "Voice Assistant",
  voice_connection_error: "Voice connection error. Please try again.",
  voice_session_inactive:
    "Voice assistant turned off after a pause. Tap the mic to start again.",
  voice_session_time_limit:
    "Voice assistant reached its time limit. Tap the mic to start again.",
  warning_empty_basket:
    "Are you sure you want to delete these products from the basket?",
  welcome_to: "Welcome to",
  yes: "Yes",
  your_order: "Your Order",

  // Voice assistant UI (options modal + floating button status) and footer.
  available_options: "Available Options",
  voice_options_instruction: "Say which options you want or say “none” to skip",
  voice_initializing: "Initializing…",
  voice_tap_to_start: "Tap to start",
  voice_listening: "Listening… (tap to pause)",
  voice_speaking: "Speaking… (tap to pause)",
  voice_added_to_cart: "Added to cart",
  voice_removed: "Removed",
  voice_order_placed: "Order placed!",
  voice_active: "Active (tap to pause)",
  powered_by: "Powered by",
  voice_product_not_found:
    "Sorry, I couldn't find '{{product}}' in our menu.",
  voice_product_out_of_stock: "Sorry, {{product}} is out of stock.",
  voice_options_prompt:
    'Would you like any options with {{product}}? Available: {{options}}. Say "no" or "none" to skip, or name the options you want.',
  voice_stock_limited:
    "Sorry, only {{available}} {{product}} available in stock.",
  voice_added_quantity_to_cart:
    "Successfully added {{quantity}} {{product}}{{options}} to your cart.",
  voice_item_not_in_cart: "'{{product}}' is not in your cart.",
  voice_removed_quantity:
    "Removed {{quantity}} {{product}} from your cart.",
  voice_cart_contents: "Your cart contains: {{items}}.",
  voice_with_options: " with {{options}}",
  voice_cart_empty_submit:
    "Your cart is empty. Please add items before submitting.",
  voice_failed_to_place_order: "Failed to place order. Please try again.",
  voice_order_error:
    "An error occurred while placing your order. Please try again.",
  our_store: "Our Store",
  currency_riyals: "Saudi riyals",
  voice_order_success:
    "Your order has been placed successfully! Order ID: {{orderId}}. Thank you for ordering with us!",
};

export default qr_en;
